<template>
  <AppHeader :action="{text: 'Past', route: 'PastOrders'}">Orders</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <SearchSort
      ref="search"
      :defaults="{q: '', search: '-', sort: 'id', order: 'asc', group: '-'}"
      :sorts="{id: 'Order ID', created_at: 'Created At', payment_mode: 'Payment Mode', delivery_person_id: 'Delivery Person ID', 'customer.id': 'Customer ID', 'customer.name': 'Customer Name', 'customer.dealer_sort': 'Customer Custom Sort'}"
      :columns="{id: 'ID', payment_mode: 'Payment Mode', 'delivery_person.name': 'Delivery Person', 'customer.id': 'Customer ID', 'customer.name': 'Customer Name', 'customer.group.name': 'Group Name', items: 'Product'}"
      :groups="[]"
      @update="searchUpdated">
    </SearchSort>

    <div class="mt-4 responsive-table">
      <table>
        <thead>
          <tr>
            <th>No.</th>
            <th>ID</th>
            <th>Date</th>
            <th>Customer</th>
            <th>Group</th>
            <th>Products</th>
            <th>Total</th>
            <th>Commission</th>
            <th>Delivery Fee</th>
            <th>Delivery Person</th>
            <th>Payment</th>
            <th @click="toggleDelivered"><i class="mx-2 ion-md-checkmark"></i></th>
            <th>Image</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="(order, index) in filteredData" :key="order.id" :class="{'bg-lightred': order.payment_mode == 'cod'}">
            <td>{{ index + 1 }}</td>
            <td>#{{ order.id }}</td>
            <td>{{ toDate(order.created_at, true) }}</td>
            <td><router-link :to="{name: 'ViewCustomer', params: {id: order.customer.id}}">{{ order.customer.name }} <small>(#{{ order.customer.id }})</small></router-link></td>
            <td>{{ order.customer.group.name }}</td>
            <td class="text-left">
              <span v-for="item in order.items" :key="item.id">{{ item.product.name }} <small>({{ item.product.quantity }})</small> x <b>{{ item.quantity }} No.</b> <br></span>
            </td>
            <td>{{ toInr(order.total.total) }}</td>
            <td>{{ toInr(order.total.commission) }}</td>
            <td>{{ toInr(order.total.shipping) }}</td>
            <td v-if="order.delivery_person_id">{{ order.delivery_person.name }} <small>({{ toDate(order.delivery_updated_at, true) }})</small></td>
            <td v-else></td>
            <td>{{ order.payment_mode }}</td>
            <td><input type="checkbox" v-model="order.is_delivered"></td>
            <td>
              <span v-if="order && order.order_image">
                <a :href="order.order_image.src" target="_system" title="View Order Image"><i class="ion-md-image text-green-500 px-5"></i></a>
              </span>
            </td>
          </tr>

          <tr v-if="orders.length == 0">
            <td class="text-xl text-center text-gray-500" colspan="100%">No Orders</td>
          </tr>

        </tbody>
      </table>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="updateOrders">Update Orders</button>
    </div>

    <div class="mt-5 text-sm leading-tight text-gray-600">When you update Orders. Your wallet will be debitted by Order amount for COD orders. You will have to collect this payment from the Customers.</div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import SearchSort from '@/components/common/SearchSort.vue';

export default {
  name: 'Orders',
  mixins: [ mixin ],
  components: { AppHeader, Loading, SearchSort },
  data() {
    return {
      state: 'loading',
      orders: [],
      currDelivered: true,
      filteredData: [],
    }
  },

  methods: {
    toggleDelivered() {
      if (!confirm('Are you sure?')) return;
      this.filteredData.forEach((item) => item.is_delivered = this.currDelivered);
      this.currDelivered = !this.currDelivered;
    },

    getData() {
      this.state = 'loading';

      this.request('GET', 'new-orders', {}, (resp) => {
        this.state = 'idle';

        if (resp.success) {
          this.orders = resp.data.orders;
          this.filteredData = resp.data.orders;
          this.$nextTick(() => {
            this.$refs.search._emit();
          });
        } else alert(resp.message ? resp.message : 'Unable to fetch Orders, try again.');
      });
    },

    updateOrders() {
      let data = this.filteredData
                    .filter((item) => item.is_delivered || item.cash_received)
                    .map((item) => {
                      if (item.is_delivered) return item.id;
                    });

      if (!confirm('Are you sure?')) return;

      this.state = 'loading';

      this.request('POST', 'new-orders', {orders: data}, (resp) => {
        this.state = 'idle';
        alert(resp.message);
        this.getData();
      });
    },

    searchUpdated(q, search, sort, order) {
      if (!q ||q == null || q.length == 0) this.filteredData = this.orders;

      if (search == '-') this.filteredData = this.orders.filter((item) => JSON.stringify(item).toLowerCase().includes(q.toLowerCase()));
      else this.filteredData = this.orders.filter((item) => JSON.stringify(this.getDeepValue(item, search)).toLowerCase().includes(q.toLowerCase()));

      this.filteredData.sort((a, b) => {
        let aData = this.getDeepValue(a, sort), bData = this.getDeepValue(b, sort);
        return (aData == bData ? 0 : aData < bData ? -1 : 1) * (order == 'desc' ? -1 : 1);
      });
    },
  },

  created() {
    if (!this.$store.state.user.id) this.$router.push('/dash');
    else this.getData();
  }
}
</script>
